angular.module('swapick')
.controller('AccountCtrl', AccountCtrl);

function AccountCtrl ($auth, $rootScope, authService,
    $ionicSideMenuDelegate, DataService, clientId, clientSecret,
    $http, Entities, $ionicLoading, initialLoaderManager, appVersion, $ionicPopup, $scope) {

    this.appVersion = appVersion;

    this.loader = initialLoaderManager.makeLoader(()=>(
        Entities.waitForUser()
        .then(u => {
            this.user = u;
            return u;
        })
        .then(u=>{
          DataService.itemsIcanGet
          .get()
          .then(resp => {
            this.totalItemsICanGet =  resp.total_items;
            $rootScope.globals.totalItemsICanGet = resp.total_items
            return resp;
          })
        })
        .then(()=>{
          DataService.ecoins
          .get()
          .then(resp => {
            this.userEcoins = resp;
            $rootScope.globals.userEcoins = parseInt(resp);
            return resp;
          })
        })
    ));

    this.loader.load();

    this.askAccountDelete = () => {
      const confirmPopup = $ionicPopup.confirm({
        title: 'Cancella Account',
        template: 'Sei sicuro di volore cancellare il tuo account? Questa operazione non è reversibile.',
        buttons: [
          {
            text: 'Annulla',
            onTap: () => false,
          },
          {
            text: 'Cancella',
            type: 'button-assertive',
            onTap: () => true,
          }
        ]
      });

      confirmPopup.then((res) => {
        if (res) {
          // TODO: Call the API for account deletion...
          $scope.AppCtrl.logout();
        }
      });
    };


}



// WEBPACK FOOTER //
// ./src/controllers/account-controller.js